import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse } from '@/types/site';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

interface CheckLoginIdResponse {
  exists: boolean;
}

export const useCheckLoginId = (loginId: string, trigger: number) => {
  return useQuery({
    queryKey: [QUERY_KEYS.users.checkLoginId, loginId, trigger],
    queryFn: async (): Promise<boolean> => {
      const response = await XHRAuthorizedClient.get<
        ApiResponse<CheckLoginIdResponse>
      >(ENDPOINTS.users.checkLoginId(loginId));
      return response.data.data.exists;
    },
    enabled: trigger > 0 && loginId.length >= 3, // 버튼을 눌렀고 조건이 맞을 때만 쿼리 실행
    staleTime: 0, // 항상 최신 데이터 확인
    refetchOnWindowFocus: false,
  });
};
